export function setDefaultImageFormat(url, format) {
  if (url.indexOf("format=") > -1) return url;

  let newUrl = `${url}&format=${format}`;

  return newUrl;
}

export const loadedBanners = new Set();

export const bannerDecode = { timeoutMs: 600 };

export function bannerSrc(details, imageFormat) {
  try {
    const url = details.getIn(["images", "bannerUrl"]);
    if (!url) return null;

    return setDefaultImageFormat(
      url + "width=450&theme=dark",
      imageFormat.get("banner"),
    );
  } catch (err) {
    return null;
  }
}

export function preloadBanner(src) {
  if (!src || loadedBanners.has(src) || bannerDecode.timeoutMs === 0) {
    return Promise.resolve();
  }

  return Promise.race([
    new Promise((resolve) => {
      const image = new Image();
      image.onload = () => {
        loadedBanners.add(src);
        resolve();
      };
      image.onerror = () => resolve();
      image.src = src;
    }),
    new Promise((resolve) => setTimeout(resolve, bannerDecode.timeoutMs)),
  ]);
}
